import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import isEqual from 'lodash/isEqual';
import configureStore from './configureStore';
var propTypes = {
  reducers: PropTypes.objectOf(PropTypes.func),
  initialState: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  middlewares: PropTypes.arrayOf(PropTypes.func),
  options: PropTypes.shape({
    devTools: PropTypes.object
  }),
  updateStoreInProduction: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  getReducers: PropTypes.func,
  getInitialState: PropTypes.func,
  getMiddlewares: PropTypes.func,
  getOptions: PropTypes.func,
  createStore: PropTypes.func,
  updateStore: PropTypes.func,
  // eslint-disable-line react/no-unused-prop-types
  storeChanged: PropTypes.func,
  // eslint-disable-line react/no-unused-prop-types
  children: PropTypes.node
};
var defaultProps = {
  reducers: {},
  initialState: {},
  middlewares: [],
  options: null,
  updateStoreInProduction: false,
  getReducers: null,
  getInitialState: null,
  getMiddlewares: null,
  getOptions: null,
  createStore: null,
  updateStore: null,
  storeChanged: null,
  children: null
};

var StoreContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(StoreContainer, _Component);

  function StoreContainer(props) {
    var _this;

    _classCallCheck(this, StoreContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StoreContainer).call(this, props));
    _this.state = {
      store: _this.createStore(props),
      storeKey: "store-".concat(new Date().getTime())
    };
    return _this;
  }

  _createClass(StoreContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var updateStoreInProduction = this.props.updateStoreInProduction;

      if ((process.env.NODE_ENV !== 'production' || updateStoreInProduction) && this.storeChanged(prevProps)) {
        this.updateStore();
      }
    }
  }, {
    key: "getReducers",
    value: function getReducers() {
      var _this$props = this.props,
          reducers = _this$props.reducers,
          getReducers = _this$props.getReducers;
      return getReducers !== null ? getReducers(reducers) : reducers;
    }
  }, {
    key: "getInitialStoreState",
    value: function getInitialStoreState() {
      var _this$props2 = this.props,
          initialState = _this$props2.initialState,
          getInitialState = _this$props2.getInitialState;
      return getInitialState !== null ? getInitialState(initialState) : initialState;
    }
  }, {
    key: "getMiddlewares",
    value: function getMiddlewares() {
      var _this$props3 = this.props,
          middlewares = _this$props3.middlewares,
          getMiddlewares = _this$props3.getMiddlewares;
      return getMiddlewares !== null ? getMiddlewares(middlewares) : middlewares;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this$props4 = this.props,
          options = _this$props4.options,
          getOptions = _this$props4.getOptions;
      return getOptions !== null ? getOptions(options) : options;
    }
  }, {
    key: "storeChanged",
    value: function storeChanged(prevProps) {
      var storeChanged = this.props.storeChanged;
      return storeChanged !== null ? storeChanged(prevProps, this.props) : isEqual(prevProps, this.props);
    }
  }, {
    key: "updateStore",
    value: function updateStore() {
      var newStore = this.replaceStore();
      this.setState({
        store: newStore,
        storeKey: "store-".concat(new Date().getTime())
      });
    }
  }, {
    key: "replaceStore",
    value: function replaceStore() {
      var store = this.state.store;
      var updateStore = this.props.updateStore;
      var reducers = this.getReducers();
      var initialState = this.getInitialStoreState();
      var middlewares = this.getMiddlewares();
      var options = this.getOptions();

      var storeState = _objectSpread({}, initialState, store.getState());

      return updateStore !== null ? updateStore(reducers, storeState, middlewares, options) : configureStore(reducers, storeState, middlewares, options);
    }
  }, {
    key: "createStore",
    value: function createStore() {
      var createStore = this.props.createStore;
      var reducers = this.getReducers();
      var initialState = this.getInitialStoreState();
      var middlewares = this.getMiddlewares();
      var options = this.getOptions();
      return createStore !== null ? createStore(reducers, initialState, middlewares, options) : configureStore(reducers, initialState, middlewares, options);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          store = _this$state.store,
          storeKey = _this$state.storeKey;
      return React.createElement(Provider, {
        store: store,
        key: storeKey
      }, children);
    }
  }]);

  return StoreContainer;
}(Component);

StoreContainer.propTypes = propTypes;
StoreContainer.defaultProps = defaultProps;
export default StoreContainer;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/StoreContainer.js
// module id = null
// module chunks = 